module.exports = __webpack_public_path__ + "static/images/lock.37836740afa4e04c96a8c127ab75cc62.svg";